"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var stimulus_1 = require("stimulus");
var axios_1 = __importDefault(require("axios"));
var dialog_store_1 = __importDefault(require("~/stores/dialog_store"));
var SHOW_SELLING_AGREEMENT_POPUP_DELAY = 500;
var MessagesController = /** @class */ (function (_super) {
    __extends(MessagesController, _super);
    function MessagesController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.connect = function () {
            if (_this.data.has('should-confirm-selling-agreement-to-user')) {
                // すぐ出すとDialogコンポーネントのマウントが間に合わない場合があるのでちょっとだけ待つ
                setTimeout(_this.showConfirmSellingAgreementDialog, SHOW_SELLING_AGREEMENT_POPUP_DELAY);
            }
        };
        _this.showConfirmSellingAgreementDialog = function () {
            dialog_store_1.default.showDialog({
                title: '買取成立しましたか？',
                description: '買取が成立している場合は「買取成立しました」を押してください',
                btnList: [
                    {
                        title: '買取成立していません',
                        customClass: 'btn-blue',
                        callback: function () { return dialog_store_1.default.hideDialog(); }
                    },
                    {
                        title: '買取成立しました',
                        customClass: 'btn-orange',
                        callback: _this.postSellingAgreement
                    }
                ],
                show_time: -1
            });
        };
        _this.postSellingAgreement = function () {
            var url = _this.data.get('selling-agreement-path');
            if (!url) {
                return;
            }
            axios_1.default.post(url)
                .then(function () { return location.reload(); })
                .catch(function () {
                dialog_store_1.default.hideDialog();
                dialog_store_1.default.showErrorDialog();
            });
        };
        return _this;
    }
    return MessagesController;
}(stimulus_1.Controller));
exports.default = MessagesController;
